import { createSlice } from "@reduxjs/toolkit";
import { adminNotificationList,adminDeleteNotification,adminReadByUser,adminReadAllMessage,adminDeleteAllMessage } from "../actions/AdminNotificationAction";
import { adminCandidateList } from "../actions/AdminActions";

const adminNotificationListSlice = createSlice({
  name: "adminNotificationList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminNotificationList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminNotificationList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminNotificationList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminDeleteNotificationSlice = createSlice({
  name: "adminNotificationList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminDeleteNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminDeleteNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminDeleteNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminReadByUserSlice = createSlice({
  name: "adminReadByUser",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminReadByUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminReadByUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminReadByUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminReadAllMessageSlice = createSlice({
  name: "adminReadAllMessage",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminReadAllMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminReadAllMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminReadAllMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminDeleteAllMessageSlice = createSlice({
  name: "adminDeleteAllMessage",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminDeleteAllMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminDeleteAllMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminDeleteAllMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});
export const reducers = {
  adminNotificationList: adminNotificationListSlice.reducer,
  adminDeleteNotification: adminDeleteNotificationSlice.reducer,
  adminReadByUser: adminReadByUserSlice.reducer,
  adminReadAllMessage: adminReadAllMessageSlice.reducer,
  adminDeleteAllMessage: adminDeleteAllMessageSlice.reducer
  
};